import { betTypeCategory } from "./positionUtils";

export function getNavigateURL(
  url_type: number,
  bet_type?: string,
  site_id?: string,
  team_id?: string,
  league_id?: string,
  bet_line?: string,
) {
  var url = "";
  if (bet_type !== undefined) {
    var bet_category = betTypeCategory(bet_type);
    if (url_type === 0) {
      if (bet_category === "ml") {
        url = `/q?site_id=${site_id}&bet_type=moneyline&intent=GetSiteMl`;
      } else if (bet_category === "ps") {
        url = `/q?site_id=${site_id}&bet_type=spread&intent=GetSitePs`;
      } else if (bet_category === "ou" && bet_type.includes("Over")) {
        url = `/q?site_id=${site_id}&bet_type=over&intent=GetSiteOver`;
      } else if (bet_category === "ou" && bet_type.includes("Under")) {
        url = `/q?site_id=${site_id}&bet_type=under&intent=GetSiteUnder`;
      }
    } else if (url_type === 1) {
      if (bet_category === "ml") {
        url = `/q?team_id=${team_id}&bet_type=moneyline&intent=GetSiteTeamMl`;
      } else if (bet_category === "ps") {
        url = `/q?team_id=${team_id}&bet_type=spread&intent=GetSiteTeamPs`;
      } else if (bet_category === "ou" && bet_type.includes("Over")) {
        url = `/q?bet_line=${bet_line}&bet_type=over&intent=GetSiteOverLine`
      } else if (bet_category === "ou" && bet_type.includes("Under")) {
        url = `/q?bet_line=${bet_line}&bet_type=under&intent=GetSiteUnderLine`
      }
    } else if (url_type === 2) {
      if (bet_category === "ml") {
        url = `/q?team_id=${team_id}&bet_type=moneyline&intent=GetSiteTeamMl`;
      } else if (bet_category === "ps") {
        url = `/q?team_id=${team_id}&bet_type=spread&intent=GetSiteTeamPs`;
      }  else if (bet_category === "ou" && bet_type.includes("Over")) {
        url = `/q?team_id=${team_id}&bet_type=over&intent=GetSiteTeamOver`;
      } else if (bet_category === "ou" && bet_type.includes("Under")) {
        url = `/q?team_id=${team_id}&bet_type=under&intent=GetSiteTeamUnder`;
      }
    }
  } else if (url_type === 3) {
    url = `/q?league=${league_id}&intent=GetLeagueOdds`;
  } else if (url_type === 4) {
    url = `/q?team_id=${team_id}&league=${league_id}&intent=GetTeamOdds`
  }
  return url;
}